module.exports = __webpack_public_path__ + "static/media/new-new-scikit-learn.282ca3b7.svg";